import { ASSETS_URL } from '../commonUtils';

export const ADD_ICON = `http://10.47.2.22/www-promos/09/09/2021/7a2c229e-79cb-4357-a98e-2e3782619106.png`;
export const LOGIN_BANNER = `https://rukminim1.flixcart.com/www/1900/1080/promos/14/09/2021/ee2c1b04-dfd5-468b-aca6-b6944d65389d.png`;
export const USER = `${ASSETS_URL}/user.jpg`;
export const CSV_IMAGE = `${ASSETS_URL}/csv.png`;
// export const LOGO = `${ASSETS_URL}/logo.png`;
// export const LOGO2 = `${ASSETS_URL}/logo-2.svg`;
// export const MM_LOGIN_LOGO = `${ASSETS_URL}/logo-2.svg`;
export const LOGO = `https://rukminim1.flixcart.com/www/500/500/promos/07/03/2022/dd0b85ab-3702-42e3-a5ec-ba1920a1bc64.png`;
export const LOGO2 = `https://rukminim1.flixcart.com/www/500/500/promos/07/03/2022/dd0b85ab-3702-42e3-a5ec-ba1920a1bc64.png`;
export const MM_LOGIN_LOGO = `https://rukminim1.flixcart.com/www/500/500/promos/07/03/2022/dd0b85ab-3702-42e3-a5ec-ba1920a1bc64.png`;
export const THREED_UPLOAD = `${ASSETS_URL}/3dupload.png`;
export const DOWNLOAD_FOLDER_LOGO = 'https://rukminim1.flixcart.com/www/72/72/promos/04/05/2022/19ddd3c5-9021-47dc-b146-903f638175bd.png';
